import React, { useState, useEffect } from 'react';
import { GraphicTemplate, SearchHeader, SecondHeader, ThirdHeader, FooterGraphicPage, SwiperPagination, SerieModal, AcordionTableIndexPeriod, AcordionTableReturnHistory, LoadingMask } from 'components';
import HigchartsBase from 'components/Highcharts/base';
import { useMyContext, useAssets } from 'hooks';



const GraphicPage = () => {
  const { assets, updateWhenChangesPeriodOrInitialApplication, changeAssetColor, removeAsset, isLoadingAssets, addAssetsBatch, benchmarkAssets } = useAssets();
  const [ selectedPeriodIndex, setSelectedPeriodIndex ] = useState(0);
  const [ selectedPeriod, setSelectedPeriod ] = useState("UM_MES");
  const [ initialApplication, setInitialApplication ] = useState(100);
  const [ isLoading, setIsLoading ] = useState(true);
  const { t, history } = useMyContext();
  const { innerWidth } = window;
  const [ initialAssets, setInitialAssets ] = useState(history.location.state && history.location.state.selectedAssets ? [...history.location.state.selectedAssets] : []);
  const [ selectedTab, setSelectedTab ] = useState(0);
  const [ indicatorsRentabilityKeys, setIndicatorsRentabilityKeys ] = useState([]);
  const [ indicatorsReturnKeys, setIndicatorsReturnKeys ] = useState([]);
  const [ indicatorsDrawdownKeys, setIndicatorsDrawdownKeys ] = useState([]);

  useEffect(async () => {
    if(benchmarkAssets.length > 0){
      setIsLoading(true);
      let initial = [ benchmarkAssets[0], ...initialAssets];
      await addAssetsBatch(initial, selectedPeriod, initialApplication);
      setIsLoading(false);
    }
  },[initialAssets, benchmarkAssets]);

  useEffect(async () => {
    await updateWhenChangesPeriodOrInitialApplication(selectedPeriod, initialApplication);
  }, [selectedPeriod]);

  useEffect(async () => {
    await updateWhenChangesPeriodOrInitialApplication(selectedPeriod, initialApplication);
  }, [initialApplication]);

  useEffect(() => {
    if(assets.length > 0){
      setIndicatorsRentabilityKeys(Object.keys(assets[0].indicatorsRentabilityData));
      setIndicatorsReturnKeys(Object.keys(assets[0].indicatorsReturnData));
      setIndicatorsDrawdownKeys(Object.keys(assets[0].indicatorsDrawdownData));
    }
  }, [assets]);

  const getIndicatorsColumns = () => {
    switch(selectedTab){
      case 0:
        return indicatorsRentabilityKeys;
      case 1:
        return  indicatorsReturnKeys;
      case 2:
        return  indicatorsDrawdownKeys;
    }
  }

  const getTypeSwiper = () => {
    switch(selectedTab){
      case 0:
        return 'indicatorsRentability';
      case 1:
        return 'indicatorsReturn';
      case 2:
        return 'indicatorsDrawdown';
    }
  }

  return (
    <GraphicTemplate
      header={<SearchHeader period={selectedPeriod} initialApplication={initialApplication}/>}
      secondHeader={<SecondHeader selectedTab={selectedTab} setSelectedTab={setSelectedTab} />}
      thirdHeader={<ThirdHeader 
        selectedPeriodIndex={selectedPeriodIndex} setSelectedPeriodIndex={setSelectedPeriodIndex}
        setSelectedPeriod={setSelectedPeriod} 
        selectedPeriod={selectedPeriod} 
        initialApplication={initialApplication} 
        setInitialApplication={setInitialApplication} 
        selectedTab={selectedTab}
        />}
      footer={<FooterGraphicPage />}
    >
      <>
        {(isLoadingAssets || isLoading) && <LoadingMask/>}
        <HigchartsBase assets={assets} selectedTab={selectedTab} />
        {innerWidth <= 920 ?
          <>
            <SwiperPagination 
              assetsData={assets} 
              type={getTypeSwiper()} 
            />
            {getTypeSwiper() !== 'indicatorsDrawdown' &&
              <SwiperPagination 
                assetsData={assets}
                type="history" 
              />
            }
          </>
          :
          <>
            <AcordionTableIndexPeriod 
              title={t['table:Header:Indicators']} 
              assetsData={assets}
              columns={getIndicatorsColumns()}
              changeAssetColor={changeAssetColor}
              removeAsset={removeAsset}
              selectedTab={selectedTab}
            />
            { selectedTab !== 2 && <AcordionTableReturnHistory 
              title={t['table:Header:ReturnHistory']} 
              assetsData={assets}
              changeAssetColor={changeAssetColor}
              removeAsset={removeAsset}
            />}
          </>
        }
        <SerieModal assetsData={assets} selectedPeriod={selectedPeriod}/>
      </>
    </GraphicTemplate>
  );
}

export default GraphicPage;